import useAccessSettingActions from '../../hooks/useAccessSettingActions'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Submit from 'components/inputs/Submit'
import Popup from 'components/popups/Popup'
import PinForm from 'components/PinForm'
import React, { useState } from 'react'

const CODE_LENGTH = 4

interface PinPopupProps {
  selected?: boolean
}

const PinPopup: React.FC<PinPopupProps> = () => {
  const [code, setCode] = useState('')
  const [warning, setWarning] = useState(false)
  const { isSending, action } = useAccessSettingActions()

  const { goBack } = useHistory()
  const { t } = useTranslation('warehouse')
  const validateCode = async () => {
    if (code?.length === CODE_LENGTH) {
      const response = await action({
        biometricsSecured: false,
        applicationPinSecured: false,
        customPin: code
      })
      if (response) goBack()
    } else {
      setWarning(true)
    }
  }

  return (
    <Popup>
      <div className='popup__pin'>
        <div className='popup__title'>
          <i className='icon icon--logo s24' />
          <div>{t('enterNewPIN')}</div>
          <div>{t(`forMAG.${process.env.REACT_APP_TYPE}`)}</div>
        </div>

        <PinForm
          autoFocus
          value={code}
          warning={warning}
          setValue={setCode}
          setWarning={setWarning}
        />

        <div className='popup__buttons'>
          <Submit
            text={t('save')}
            isLoading={isSending}
            block={isSending || code?.length !== CODE_LENGTH}
            action={validateCode}
          />

          <BackBtn text={t('cancel')} />
        </div>
      </div>
    </Popup>
  )
}

export default PinPopup